import cn from 'classnames';
import mixpanel from 'mixpanel-browser';
import { Tooltip, TooltipTrigger, TooltipContent } from '@leadsnavi/ui-kit';
import useStore from '@/stores/sider-menu';
import UserIcon from '@/assets/icons/user.svg?react';
import { authModalService } from '@/services/authModal';

export default function HandleLogin() {
  const { collapsed } = useStore();

  const handleClick = () => {
    authModalService.openLogin();
    mixpanel.track('profile_login_click');
  };

  if (collapsed) {
    return (
      <div className="pt-30">
        <Tooltip>
          <TooltipTrigger asChild>
            <div className={cn('py-1.5 flex items-center cursor-pointer justify-center')} onClick={handleClick}>
              <UserIcon />
            </div>
          </TooltipTrigger>
          <TooltipContent side="right">Log in</TooltipContent>
        </Tooltip>
      </div>
    );
  }

  return (
    <div className="px-3 pt-3">
      <div
        className={cn('px-2 py-1.5 flex items-center cursor-pointer gap-2 select-none rounded-sm transition')}
        onClick={handleClick}
      >
        <UserIcon />
        <div className="text-sm font-medium text-[#262626]">Log in</div>
      </div>
    </div>
  );
}
